"use strict";

import 'materialize-css';
import './collapse_icons';
import 'datatables.net-dt';
import 'datatables.net';

$(document).ready(function($){

    $('.sidenav').sidenav({
        edge: 'right',
        closeOnClick: true,
        draggable: true
    });

    $('.sidenav-close').on('click', function () {
        $('.sidenav').sidenav('close');
    });

    $('.catalog-table table').DataTable({
          "oLanguage": {
            "sLengthMenu": "Pokaż _MENU_ ",
            "sSearch": "Szukaj",
            "oPaginate": {
              "sFirst": "Pierwsza strona",
              "sPrevious": "Poprzednia strona",
              "sNext": "Nstępna strona",
              "sLast": "Ostatnia strona"
            }

          }
    });

    $('.home .accordion li.hover').on('touchstart touchend', function(e) {
      e.stopPropagation()
      $(this).toggleClass('hover_effect');
  });

  $('.home .accordion li.hover').on('mouseover mouseleave', function(e) {
    e.preventDefault();
    $(this).toggleClass('hover_effect');
});

    // change button text on hop slider

    $('.wpsisac-slider-readmore').text('Kup teraz');

});
